<template>
  <div class="player">
    <video-player
      class="vjs-custom-skin"
      :options="playerOptions"
      :playsinline="true"
      ref="video"
      @statechanged="playerStateChanged($event)"
      @ready="playerReadied($event)"
    ></video-player>
  </div>
</template>

<script>
import videojs from 'video.js';
import { videoPlayer } from './video-player';
// require videojs style
import 'video.js/dist/video-js.css';
import './video-player/custom-theme.css';
export default {
  components: {
    'video-player': videoPlayer,
  },
  props: ['src', 'poster', 'isStart', 'autoPlay'],
  data() {
    return {
      playerOptions: {
        height: (200 * window.innerWidth) / 375,
        autoplay: true,
        playbackRates: [0.7, 1, 1.3, 1.5, 1.7],
        sources: [
          {
            type: 'video/mp4',
            src: '',
          },
        ],
        controls: false,
        poster: '',
      },
    };
  },
  methods: {
    playerReadied(player) {
      const track = new videojs.AudioTrack({
        id: 'my-spanish-audio-track',
        kind: 'translation',
        label: 'Spanish',
        language: 'es',
      });
      player.audioTracks().addTrack(track);
      // Get the current player's AudioTrackList object.
      const audioTrackList = player.audioTracks();

      // Listen to the "change" event.
      audioTrackList.addEventListener('change', function () {
        // Log the currently enabled AudioTrack label.
        for (let i = 0; i < audioTrackList.length; i++) {
          const track = audioTrackList[i];
          if (track.enabled) {
            videojs.log(track.label);
            return;
          }
        }
      });
    },
    playerStateChanged(playerCurrentState) {
      if (playerCurrentState.error) {
        this.$emit('errorFn');
      }
    },
  },
  mounted() {},
  created() {
    this.playerOptions.sources[0].src = this.src;
    this.playerOptions.sources[0].type = this.type || 'video/mp4';
    this.playerOptions.poster = this.poster;
  },
};
</script>
<style lang="less" scoped>
.player {
  flex: 1;
  width: 100vw;
  height: 215px;
  position: relative;
  top: -30px;
  /deep/ video {
    height: 215px;
  }
  /deep/ .vjs-custom-skin > .video-js .vjs-big-play-button {
    transform: scale(1.2);
  }
  /deep/ .vjs-big-play-button {
    border: none !important;
    background-color: transparent !important;
  }
}
.posterImg {
  position: relative;
}
.posterImg:before {
  /* content: "";
      display: block;
      width:80px;
      height:80px;
      position: absolute;
      left:50%;
      margin-left:-40px;
      top:50%;
      margin-top:-40px;
      background:url('https://picbed.qunarzz.com/dff80ec222edc1cb9e0b33dcf39404bd.png') no-repeat;
      background-size:100% 100%; */
}
</style>
